import React, { useEffect, useRef } from 'react';

import { formatNumber,formatSubPageText } from '../../../utils';
import { CITY_SUBPAGES, CLUSTER_HEADER_CATEGORY } from '../../../utils/constant';

const CityClusterHeaderTitle = ({
  subPageName,
  criteria,
  showJobsCount = false,
  noH1Tag,
  headerTitle,
  getPageTitle,
  ...data
}) => {
  const { city, stateAbbr } = criteria;
  const formattedSubPageName = formatSubPageText(subPageName, CLUSTER_HEADER_CATEGORY.CITY);

  const content = () => {
    if (headerTitle) return headerTitle.format(criteria);

    switch (subPageName) {
      case CITY_SUBPAGES.JOB:
        return `Jobs in ${city}, ${stateAbbr}`;
      case CITY_SUBPAGES.PART_TIME_JOBS:
        return data?.metadata?.H1 || `Part Time ${city}, ${stateAbbr} Jobs`;
      case CITY_SUBPAGES.SALARY:
        return `Average Salary in ${city}, ${stateAbbr}`;

      default:
        return `${formattedSubPageName}`;
    }
  };

  const TitleTag = noH1Tag ? 'p' : 'h1';
  const title = content();
  const titleRef = useRef(null);

    useEffect(() => {
      if (getPageTitle) {
        const text = titleRef?.current?.textContent;
        getPageTitle(text);
      }
    }, [getPageTitle]);

  return (
    <>
      {!showJobsCount && (
        <TitleTag className="career-cluster-header-title z-my-36 career-title-only" ref={titleRef}>
          {title}
        </TitleTag>
      )}
      {showJobsCount && (
        <div className="career-cluster-header-title career-title-only z-my-36">
          <TitleTag ref={titleRef}>{title}</TitleTag>
          <span className="d-inline">{` - ${formatNumber(
            data?.jobsCountForHeader ?? data?.cityJobs?.totalJobs ?? 0
          )} Jobs`}</span>
        </div>
      )}
    </>
  );
};

export default CityClusterHeaderTitle;
